"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2019, a Tencent company. All rights reserved.
 */

/**
 * @fileoverview 组件对应结构的默认className
 */
var _default = {
  Carousel: 'spaui-carousel',
  CarouselSliderClassName: 'slide',
  CarouselIndicatorsClassName: 'carousel-indicators',
  CarouselInnerClassName: 'carousel-inner',
  CarouselItemClassName: 'item',
  CarouselControlClassName: 'carousel-control',
  CarouselLeftControlClassName: 'left',
  CarouselRightControlClassName: 'right',
  CarouselChevronLeftClassName: 'chevron-left',
  CarouselChevronRightClassName: 'chevron-right',
  CarouselChevronHiddenClassName: 'visually-hidden'
};
exports["default"] = _default;